import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default (ticketId, note) =>
  f3tch(`/crm/tickets/${ticketId}/notes/`)
    .profile(profile())
    .body(note)
    .post();
